import '../../assets/components/Banner/Banner.css';//#region lib/components/Banner/Banner.module.css
var e = "_banner_o0bpu_1", t = { banner: e };
//#endregion
export { e as banner, t as default };
